import * as requests from '../api-request'
import getToken from '../get-token'

export const schedulingPreview = async (data = {}, token) => {
  token = token || (await getToken())
  return requests.toBlob('POST', 'scheduling/preview', data, token)
}

export const schedulingDownloadExcel = async (data = {}, token) => {
  token = token || (await getToken())

  return requests.toBlob('POST', 'scheduling/download_excel', data, token)
}

export const downloadDOOD = async (data = {}, token) => {
  token = token || (await getToken())

  return requests.toBlob('POST', 'scheduling/download_dood', data, token)
}

export const saveHistory = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'scheduling/create_history', data, token)
}

export const deleteHistory = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'scheduling/delete_history', data, token)
}

export const checkPermission = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'scheduling/check_permission', data, token)
}

export const getHistory = async (data, token) => {
  token = token || (await getToken())
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `scheduling/get_history?${queryString}`, data, token)
}

export const getLatest = async (data, token) => {
  token = token || (await getToken())
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `scheduling/latest?${queryString}`, data, token)
}
